/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 22V2M2 12H22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 8.4C2 6.15979 2 5.03968 2.43597 4.18404C2.81947 3.43139 3.43139 2.81947 4.18404 2.43597C5.03968 2 6.15979 2 8.4 2H12H15.6C17.8402 2 18.9603 2 19.816 2.43597C20.5686 2.81947 21.1805 3.43139 21.564 4.18404C22 5.03968 22 6.15979 22 8.4V12V15.6C22 17.8402 22 18.9603 21.564 19.816C21.1805 20.5686 20.5686 21.1805 19.816 21.564C18.9603 22 17.8402 22 15.6 22H12H8.4C6.15979 22 5.03968 22 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43597 19.816C2 18.9603 2 17.8402 2 15.6V12V8.4Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="4"
				fill="currentColor"
			/>
			<path
				d="M12 22H15.6C17.8402 22 18.9603 22 19.816 21.564C20.5686 21.1805 21.1805 20.5686 21.564 19.816C22 18.9603 22 17.8402 22 15.6V12M12 22H8.4C6.15979 22 5.03968 22 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43597 19.816C2 18.9603 2 17.8402 2 15.6V12M12 22V2M2 12V8.4C2 6.15979 2 5.03968 2.43597 4.18404C2.81947 3.43139 3.43139 2.81947 4.18404 2.43597C5.03968 2 6.15979 2 8.4 2H12M2 12H22M22 12V8.4C22 6.15979 22 5.03968 21.564 4.18404C21.1805 3.43139 20.5686 2.81947 19.816 2.43597C18.9603 2 17.8402 2 15.6 2H12"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M11.25 2.21C11.25 1.87397 11.25 1.70595 11.1846 1.57761C11.1271 1.46471 11.0353 1.37292 10.9224 1.3154C10.794 1.25 10.626 1.25 10.29 1.25H9.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V10.29C1.25 10.626 1.25 10.794 1.3154 10.9224C1.37292 11.0353 1.46471 11.1271 1.57761 11.1846C1.70595 11.25 1.87397 11.25 2.21 11.25H10.29C10.626 11.25 10.794 11.25 10.9224 11.1846C11.0353 11.1271 11.1271 11.0353 11.1846 10.9224C11.25 10.794 11.25 10.626 11.25 10.29V2.21Z"
				fill="currentColor"
			/>
			<path
				d="M2.21 12.75C1.87397 12.75 1.70595 12.75 1.57761 12.8154C1.46471 12.8729 1.37292 12.9647 1.3154 13.0776C1.25 13.206 1.25 13.374 1.25 13.71V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H10.29C10.626 22.75 10.794 22.75 10.9224 22.6846C11.0353 22.6271 11.1271 22.5353 11.1846 22.4224C11.25 22.294 11.25 22.126 11.25 21.79V13.71C11.25 13.374 11.25 13.206 11.1846 13.0776C11.1271 12.9647 11.0353 12.8729 10.9224 12.8154C10.794 12.75 10.626 12.75 10.29 12.75H2.21Z"
				fill="currentColor"
			/>
			<path
				d="M12.75 21.79C12.75 22.126 12.75 22.294 12.8154 22.4224C12.8729 22.5353 12.9647 22.6271 13.0776 22.6846C13.206 22.75 13.374 22.75 13.71 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V13.71C22.75 13.374 22.75 13.206 22.6846 13.0776C22.6271 12.9647 22.5353 12.8729 22.4224 12.8154C22.294 12.75 22.126 12.75 21.79 12.75H13.71C13.374 12.75 13.206 12.75 13.0776 12.8154C12.9647 12.8729 12.8729 12.9647 12.8154 13.0776C12.75 13.206 12.75 13.374 12.75 13.71V21.79Z"
				fill="currentColor"
			/>
			<path
				d="M21.79 11.25C22.126 11.25 22.294 11.25 22.4224 11.1846C22.5353 11.1271 22.6271 11.0353 22.6846 10.9224C22.75 10.794 22.75 10.626 22.75 10.29V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H13.71C13.374 1.25 13.206 1.25 13.0776 1.3154C12.9647 1.37292 12.8729 1.46471 12.8154 1.57761C12.75 1.70595 12.75 1.87397 12.75 2.21V10.29C12.75 10.626 12.75 10.794 12.8154 10.9224C12.8729 11.0353 12.9647 11.1271 13.0776 11.1846C13.206 11.25 13.374 11.25 13.71 11.25H21.79Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M12 22H15.6C17.8402 22 18.9603 22 19.816 21.564C20.5686 21.1805 21.1805 20.5686 21.564 19.816C22 18.9603 22 17.8402 22 15.6V12M12 22H8.4C6.15979 22 5.03968 22 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43597 19.816C2 18.9603 2 17.8402 2 15.6V12M12 22L12 12L12 9M2 12V8.4C2 6.15979 2 5.03968 2.43597 4.18404C2.81947 3.43139 3.43139 2.81947 4.18404 2.43597C5.03968 2 6.15979 2 8.4 2H12M2 12H15M22 12V8.4C22 6.15979 22 5.03968 21.564 4.18404C21.1805 3.43139 20.5686 2.81947 19.816 2.43597C18.9603 2 17.8402 2 15.6 2H12M22 12H19M12 2V5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12 22H15.6C17.8402 22 18.9603 22 19.816 21.564C20.5686 21.1805 21.1805 20.5686 21.564 19.816C22 18.9603 22 17.8402 22 15.6V12M12 22H8.4C6.15979 22 5.03968 22 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43597 19.816C2 18.9603 2 17.8402 2 15.6V12M12 22V2M2 12V8.4C2 6.15979 2 5.03968 2.43597 4.18404C2.81947 3.43139 3.43139 2.81947 4.18404 2.43597C5.03968 2 6.15979 2 8.4 2H12M2 12H22M22 12V8.4C22 6.15979 22 5.03968 21.564 4.18404C21.1805 3.43139 20.5686 2.81947 19.816 2.43597C18.9603 2 17.8402 2 15.6 2H12"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<g opacity="0.32">
				<path
					d="M11.25 2.21C11.25 1.87397 11.25 1.70595 11.1846 1.57761C11.1271 1.46471 11.0353 1.37292 10.9224 1.3154C10.794 1.25 10.626 1.25 10.29 1.25H9.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V10.29C1.25 10.626 1.25 10.794 1.3154 10.9224C1.37292 11.0353 1.46471 11.1271 1.57761 11.1846C1.70595 11.25 1.87397 11.25 2.21 11.25H10.29C10.626 11.25 10.794 11.25 10.9224 11.1846C11.0353 11.1271 11.1271 11.0353 11.1846 10.9224C11.25 10.794 11.25 10.626 11.25 10.29V2.21Z"
					fill="currentColor"
				/>
				<path
					d="M12.75 21.79C12.75 22.126 12.75 22.294 12.8154 22.4224C12.8729 22.5353 12.9647 22.6271 13.0776 22.6846C13.206 22.75 13.374 22.75 13.71 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V13.71C22.75 13.374 22.75 13.206 22.6846 13.0776C22.6271 12.9647 22.5353 12.8729 22.4224 12.8154C22.294 12.75 22.126 12.75 21.79 12.75H13.71C13.374 12.75 13.206 12.75 13.0776 12.8154C12.9647 12.8729 12.8729 12.9647 12.8154 13.0776C12.75 13.206 12.75 13.374 12.75 13.71V21.79Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M2.21 12.75C1.87397 12.75 1.70595 12.75 1.57761 12.8154C1.46471 12.8729 1.37292 12.9647 1.3154 13.0776C1.25 13.206 1.25 13.374 1.25 13.71V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H10.29C10.626 22.75 10.794 22.75 10.9224 22.6846C11.0353 22.6271 11.1271 22.5353 11.1846 22.4224C11.25 22.294 11.25 22.126 11.25 21.79V13.71C11.25 13.374 11.25 13.206 11.1846 13.0776C11.1271 12.9647 11.0353 12.8729 10.9224 12.8154C10.794 12.75 10.626 12.75 10.29 12.75H2.21Z"
				fill="currentColor"
			/>
			<path
				d="M21.79 11.25C22.126 11.25 22.294 11.25 22.4224 11.1846C22.5353 11.1271 22.6271 11.0353 22.6846 10.9224C22.75 10.794 22.75 10.626 22.75 10.29V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H13.71C13.374 1.25 13.206 1.25 13.0776 1.3154C12.9647 1.37292 12.8729 1.46471 12.8154 1.57761C12.75 1.70595 12.75 1.87397 12.75 2.21V10.29C12.75 10.626 12.75 10.794 12.8154 10.9224C12.8729 11.0353 12.9647 11.1271 13.0776 11.1846C13.206 11.25 13.374 11.25 13.71 11.25H21.79Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
